import { UserRole } from 'app/core/interfaces/login.interface';

export const USER_BASE_ROLES: readonly UserRole[] = [
  UserRole.Owner,
  UserRole.Administrator,
];

export const REQUEST_PANEL_BASE_ROLES: readonly UserRole[] = [
  UserRole.Owner,
  UserRole.Administrator,
  UserRole.Manager,
];

export const WORKSPACE_ROLES: readonly UserRole[] = [
  UserRole.Owner,
  UserRole.Administrator,
  UserRole.Manager,
];

export const KNOWLEDGE_BASE_ROLES: readonly UserRole[] = [
  UserRole.Owner,
  UserRole.Administrator,
];

export const METRICS_ROLES: readonly UserRole[] = [
  UserRole.Owner,
  UserRole.Administrator,
  UserRole.Manager,
];